import { useSearchParams } from '@occc-app/hooks/useSearchParams';
import { MemberDetailsPageTab } from './types';

const POINT_EXPIRATIONS_PREFIX = 'point-expiration';
const TRANSACTIONS_PREFIX = 'transactions';
const WALLETS_PREFIX = 'wallets';
const OFFERS_PREFIX = 'offers';
const IN_PROGRESS_OFFERS_PREFIX = 'ioffers';
const VOUCHERS_PREFIX = 'vouchers';
const AUDIENCES_PREFIX = 'audiences';
const COMMENTS_PREFIX = 'comments';

export const POINT_EXPIRATIONS_AFTER_PARAM = `${POINT_EXPIRATIONS_PREFIX}-after`;
export const POINT_EXPIRATIONS_BEFORE_PARAM = `${POINT_EXPIRATIONS_PREFIX}-before`;
export const POINT_EXPIRATIONS_START_DATE_PARAM = `${POINT_EXPIRATIONS_PREFIX}-startDate`;
export const POINT_EXPIRATIONS_END_DATE_PARAM = `${POINT_EXPIRATIONS_PREFIX}-endDate`;

export const TRANSACTIONS_AFTER_PARAM = `${TRANSACTIONS_PREFIX}-after`;
export const TRANSACTIONS_BEFORE_PARAM = `${TRANSACTIONS_PREFIX}-before`;
export const TRANSACTIONS_START_DATE_PARAM = `${TRANSACTIONS_PREFIX}-startDate`;
export const TRANSACTIONS_END_DATE_PARAM = `${TRANSACTIONS_PREFIX}-endDate`;
export const TRANSACTIONS_TYPE_PARAM = `${TRANSACTIONS_PREFIX}-type`;
export const TRANSACTIONS_POINT_CHANGE_TYPE_PARAM = `${TRANSACTIONS_PREFIX}-pointChangeType`;

export const TRANSACTIONS_PARAM_NAMES: Parameters<typeof useSearchParams>[0] = {
  searchParamName: `${TRANSACTIONS_PREFIX}-search`,
  afterParamName: TRANSACTIONS_AFTER_PARAM,
  beforeParamName: TRANSACTIONS_BEFORE_PARAM,
};

export const WALLETS_AFTER_PARAM = `${WALLETS_PREFIX}-after`;
export const WALLETS_BEFORE_PARAM = `${WALLETS_PREFIX}-before`;

export const AUDIENCES_AFTER_PARAM = `${AUDIENCES_PREFIX}-after`;
export const AUDIENCES_BEFORE_PARAM = `${AUDIENCES_PREFIX}-before`;
export const AUDIENCES_STATUS_PARAM = `${AUDIENCES_PREFIX}-status`;

export const OFFERS_AFTER_PARAM = `${OFFERS_PREFIX}-after`;
export const OFFERS_BEFORE_PARAM = `${OFFERS_PREFIX}-before`;

export const OFFERS_ENGAGEMENT_TYPE_PARAM = `${OFFERS_PREFIX}-engagementType`;
export const OFFERS_ELIGIBILITY_PARAM = `${OFFERS_PREFIX}-eligibility`;
export const OFFERS_VISIBLE_STATUS_PARAM = `${OFFERS_PREFIX}-visibleStatus`;

export const OFFERS_PARAM_NAMES: Parameters<typeof useSearchParams>[0] = {
  searchParamName: `${OFFERS_PREFIX}-search`,
  afterParamName: OFFERS_AFTER_PARAM,
  beforeParamName: OFFERS_BEFORE_PARAM,
};

export const IN_PROGRESS_OFFERS_AFTER_PARAM = `${IN_PROGRESS_OFFERS_PREFIX}-after`;
export const IN_PROGRESS_OFFERS_BEFORE_PARAM = `${IN_PROGRESS_OFFERS_PREFIX}-before`;
export const IN_PROGRESS_OFFERS_ELIGIBILITY_PARAM = `${IN_PROGRESS_OFFERS_PREFIX}-eligibility`;

export const IN_PROGRESS_OFFERS_PARAM_NAMES: Parameters<typeof useSearchParams>[0] = {
  searchParamName: `${IN_PROGRESS_OFFERS_PREFIX}-search`,
  afterParamName: IN_PROGRESS_OFFERS_AFTER_PARAM,
  beforeParamName: IN_PROGRESS_OFFERS_BEFORE_PARAM,
};

export const VOUCHERS_AFTER_PARAM = `${VOUCHERS_PREFIX}-after`;
export const VOUCHERS_BEFORE_PARAM = `${VOUCHERS_PREFIX}-before`;
export const VOUCHERS_SOURCE_TYPE_PARAM = `${VOUCHERS_PREFIX}-sourceType`;
export const VOUCHERS_STATE_PARAM = `${VOUCHERS_PREFIX}-state`;
export const VOUCHERS_CREATED_AT_RANGE_PARAM = `${VOUCHERS_PREFIX}-created-at-range`;
export const VOUCHERS_CREATED_AT_START_PARAM = `${VOUCHERS_PREFIX}-created-at-start`;
export const VOUCHERS_CREATED_AT_END_PARAM = `${VOUCHERS_PREFIX}-created-at-end`;
export const VOUCHERS_EXPIRE_AT_RANGE_PARAM = `${VOUCHERS_PREFIX}-expire-at-range`;
export const VOUCHERS_EXPIRE_AT_START_PARAM = `${VOUCHERS_PREFIX}-expire-at-start`;
export const VOUCHERS_EXPIRE_AT_END_PARAM = `${VOUCHERS_PREFIX}-expire-at-end`;
export const VOUCHERS_SORT_FIELD_PARAM = `${VOUCHERS_PREFIX}-sort-field`;
export const VOUCHERS_SORT_DIRECTION_PARAM = `${VOUCHERS_PREFIX}-sort-direction`;

export const VOUCHERS_PARAM_NAMES: Parameters<typeof useSearchParams>[0] = {
  searchParamName: `${VOUCHERS_PREFIX}-search`,
  afterParamName: VOUCHERS_AFTER_PARAM,
  beforeParamName: VOUCHERS_BEFORE_PARAM,
};

export const COMMENTS_PAGE_SIZE = 6;
export const COMMENTS_AFTER_PARAM = `${COMMENTS_PREFIX}-after`;
export const COMMENTS_BEFORE_PARAM = `${COMMENTS_PREFIX}-before`;
export const COMMENTS_START_DATE_PARAM = `${COMMENTS_PREFIX}-startDate`;
export const COMMENTS_END_DATE_PARAM = `${COMMENTS_PREFIX}-endDate`;
export const COMMENTS_AUTHOR_EMAIL_PARAM = `${COMMENTS_PREFIX}-author-email`;
export const COMMENTS_PARAM_NAMES: Parameters<typeof useSearchParams>[0] = {
  searchParamName: `${COMMENTS_PREFIX}-search`,
  afterParamName: COMMENTS_AFTER_PARAM,
  beforeParamName: COMMENTS_BEFORE_PARAM,
};
export const COMMENTS_AUTHOR_EMAIL_PARAM_NAMES: Parameters<typeof useSearchParams>[0] = {
  searchParamName: COMMENTS_AUTHOR_EMAIL_PARAM,
  afterParamName: COMMENTS_AFTER_PARAM,
  beforeParamName: COMMENTS_BEFORE_PARAM,
};

export const MEMBER_DETAILS_TAB_PARAM = 'tab';
export const DEFAULT_MEMBER_DETAILS_TAB: MemberDetailsPageTab = 'details';
export const MEMBER_DETAILS_TABS: MemberDetailsPageTab[] = [
  'details',
  'program',
  'wallets',
  'employee',
  'referrals',
  'customData',
];
